module.exports = __webpack_public_path__ + "img/googleplay-sp.625519b4.svg";